import Vue from "vue"
import VueRouter from "vue-router"
// 解决上面跳转加参数报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

// 修改路由replace方法,阻止重复点击报错
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
Vue.use(VueRouter)
const PUBLIC_PATH = process.env.VUE_APP_STATIC_URL + (process.env.VUE_APP_IS_GRAY ? "/page-v2" : "/page-v21")
export default new VueRouter({
  base: PUBLIC_PATH,
  routes: [
    {
      path: "/",
      component: () => import("../views/bigScreenPreview.vue"),
      meta: {
        title: "可视化大屏 "
      }
    },
    {
      path: "/home",
      component: () => import("../views/Home.vue"),
      meta: {
        title: "pc编辑页"
      }
    },
    {
      path: "/homeMoudles",
      component: () => import("../views/HomeMoudles.vue"),
      meta: {
        title: "pc模块编辑页"
      }
    },
    {
      path: "/appHome",
      component: () => import("../views/appHome.vue")
    },
    {
      path: "/bigScreen",
      component: () => import("../views/bigScreen.vue")
    },
    {
      path: "/preview",
      component: () => import("../views/Preview.vue")
    },
    {
      path: "/bigScreenList",
      component: () => import("../views/bigScreenList.vue"),
      meta: {
        title: "大屏列表页"
      }
    },
    {
      path: "/homeList",
      component: () => import("../views/homeList.vue"),
      meta: {
        title: "列表页"
      }
    },
    {
      path: "/uiModule",
      component: () => import("../views/uiComponentUseDoc/uiComponentUseDoc.vue")
    },
    {
      path: "/bigScreenPreview",
      component: () => import("../views/bigScreenPreview.vue"),
      meta: {
        title: "可视化大屏 "
      }
    },
    {
      path: "/v2/p/:p",
      component: () => import("../views/bigScreenPreview.vue"),
      meta: {
        title: "可视化大屏 "
      }
    },
    {
      path: "/ssrPreview",
      component: () => import("../views/ssr_preview.vue")
    },
    {
      path: "/deviceError",
      component: () => import("../views/bigScreenError.vue"),
      meta: {
        title: "可视化大屏 "
      }
    },
    {
      path:'/group/:id/:id1/:id2',
      component: () => import("../views/bigScreenPreview.vue"),
      meta: {
        title: "可视化大屏 "
      }
    },
    {
      path:'/group/:id/:id1/',
      component: () => import("../views/bigScreenPreview.vue"),
      meta: {
        title: "可视化大屏 "
      }
    },
    {
      path:'/page/:id/show',
      component: () => import("../views/bigScreenPreview.vue"),
      meta: {
        title: "可视化大屏 "
      }
    }
  ],
  mode: "history"
})